import { useAlertBasic } from "@/hooks/common";
import { t } from "@/services/i18n";
import { AxiosResponse } from "axios";
import { App } from "vue";

export const responseHandler = (response: AxiosResponse, app?: App) => {
  const router = app?.config.globalProperties.$router;
  const store = app?.config.globalProperties.$store;
  const { alert } = useAlertBasic();
  if (response.data.Code === 10011 || response.data.Code === 10012) {
    store.dispatch("touch/clearTouchTimer");
    if (response.config.url != "/user/get") {
      router.replace({ name: "login" });
      const tips = t("http.tokenInvalid");
      alert(tips);
    }
  } else if (response.data.Code === 10008) {
    // 没有数据访问权限
    const tips = t("http.noDataAccess");
    alert(tips);
  } else if (response.data.Code === 10013) {
    store.dispatch("touch/clearTouchTimer");
    router.replace({ name: "login" });
    const tips = t("http.yourAccountHasLoggedInElsewhere");
    alert(tips);
  }
  return response;
};
